<template>
   <div
        style="position:relative; width:100%"
    >
        <div
             :id="graphID"
            style="position:relative; width:100%"
        ></div>
        <div class="legent-chart">
            <div class="d-flex mb-1">
                <img
                    src="/icon/line-strike.svg"
                    class="line-size"
                    alt=""
                />
                ETH
            </div>
            <div class="d-flex">
                <img
                    src="/icon/line-eth.svg"
                    class="line-size"
                    alt=""
                />
                    Strike Price
            </div>
        </div>
    </div>
</template>

<script>

import { createChart, isBusinessDay, LineStyle } from "lightweight-charts";


export default {
    props:{
        graphID: {
            require: true
        },
        data:{
            type: Array,
            default() {
                return []
            }
        }

    },
    methods:{
        displayGraph(areaData, extraData, graphContainerId, graphId) {
            var width = document.getElementById(graphId).parentNode.scrollWidth;

            if (!width) {
                width = document.getElementById(graphId).parentNode.scrollWidth;
                width = width - 5;
            }
            //
            let height = 250;

            //var switcherElement = createSimpleSwitcher(intervals, intervals[0], this.syncToInterval);
            document.getElementById(graphId).innerHTML = "";
            const chart = createChart(document.getElementById(graphId), {
                width: width,
                height: height,
                chart: {},
                localization: {
                    priceFormatter: price => "$ " + price.toFixed(1)
                },
                series: {
                    topColor: "rgba(32, 226, 47, 0.56)",
                    bottomColor: "rgba(32, 226, 47, 0.04)",
                    lineColor: "rgba(68, 195, 122, 0.6)"
                },
                rightPriceScale: {
                    borderVisible: false,
                    scaleMargins: {
                        top: 0.1,
                        bottom: 0.1
                    }
                },
                timeScale: {
                    borderColor: "#757676",
                    visible: true,
                    timeVisible: true,
                    secondsVisible: false,
                    borderVisible: true,
                    shiftVisibleRangeOnNewBar: false,
                    fixLeftEdge: true,
                    lockVisibleTimeRangeOnResize: true,
                    rightBarStaysOnScroll: false,
                    tickMarkFormatter: time => {
                        const date = new Date(time.year, time.month, time.day);
                        return date.getMonth() + 1 + "/" + date.getDate();
                    }
                },
                grid: {
                    horzLines: {
                        color: "transparent"
                    },
                    vertLines: {
                        color: "transparent"
                    }
                },
                crosshair: {
                    vertLine: {
                        color: "transparent",
                        width: 0.5,
                        style: 1,
                        visible: false,
                        labelVisible: false
                    },
                    horzLine: {
                        color: "transparent",
                        width: 0.5,
                        style: 0,
                        visible: false,
                        labelVisible: true
                    },
                    mode: 1
                }
                // crosshair: {
                //     horzLine: {
                //         visible: false,
                //     },
                // },
            });
            chart.applyOptions({
                layout: {
                    backgroundColor: "transparent",
                    textColor: "#FFF"
                }
            });
            const areaSeries = chart.addAreaSeries({
                topColor: "rgba(68, 195, 122, 0.6)",
                bottomColor: "rgba(8, 11, 88, 0.1)",
                lineColor: "rgba(68, 195, 122, 0.6)",
                lineWidth: 2,
                priceFormat: {
                    type: "volume",
                    precision: 3,
                    minMove: 0.001
                },
                crosshairMarkerVisible: true,
                crosshairMarkerRadius: 3,
                crosshairMarkerBorderColor: "rgb(255, 255, 255, 1)",
                crosshairMarkerBackgroundColor: "rgb(34, 150, 243, 1)",
                autoscaleInfoProvider: () => ({
                    priceRange: {
                        minValue: 0.080083,
                        maxValue: 0.435015
                    }
                }),
                rightPriceScale: {
                    scaleMargins: {
                        top: 0.6,
                        bottom: 0.05
                    }
                }
            });
            const extraSeries = chart.addAreaSeries({
                topColor: "transparent",
                bottomColor: "transparent",
                lineColor: "#6271FF",
                lineStyle: LineStyle.Dashed
            });

            areaSeries.setData(areaData);
            extraSeries.setData(extraData);
            chart.timeScale().fitContent();
            //chart.removeSeries(series);

            //chart.timeScale().fitContent();

            function businessDayToString(businessDay) {
                return new Date(
                    Date.UTC(
                        businessDay.year,
                        businessDay.month - 1,
                        businessDay.day,
                        0,
                        0,
                        0
                    )
                ).toLocaleDateString();
            }

            // document.body.style.position = 'relative';
            // var legend = document.createElement('div');
            //     legend.classList.add('legendku');
            //     document.body.appendChild(legend);

            //     var firstRow = document.createElement('div');
            //     firstRow.innerText = 'ETC USD 7D VWAP';
            //     firstRow.style.color = 'white';
            //     legend.appendChild(firstRow);

            //     chart.subscribeCrosshairMove((param) => {

            //         firstRow.innerText = 'ETC USD 7D VWAP';

            //     });
            chart.timeScale().fitContent();
        }
    }
}
</script>

<style>

</style>
